import { MapPinIcon, IdentificationIcon } from "@heroicons/react/24/solid";
import { UseFormGetValues, UseFormHandleSubmit, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormState } from "../../Pages/Sponsor/HubsAddPage";
import { Input } from "Components/Input";
import { useHistory } from "react-router-dom";
import { ImageInput } from "Components/ImageInput";
import HubLocationPicker from "Components/Sponsor/HubLocationPicker";
import { InputPostalCode } from "Components/PostalCodeInput";
import {
  AdminPage,
  Card,
  AdminError,
  BackLink,
  PrimaryButton,
  GhostButton,
} from "../../Pages/Sponsor/adminShared";

const HubsAddForm = ({ handleFormSubmit, handleSubmit, register, watch, errors, setValue, getValues,
  setError, error }: {
    handleFormSubmit: any, handleSubmit: UseFormHandleSubmit<FormState>,
    register: UseFormRegister<FormState>, watch: any, errors: any, setValue: UseFormSetValue<FormState>, getValues: UseFormGetValues<FormState>,
    setError: any, error: string
  }) => {
  const history = useHistory();
  return (
    <AdminPage eyebrow="STORES" title="店舗を追加" icon="shop" maxWidth={760}>
      <BackLink to="/sponsor/hubs">店舗一覧に戻る</BackLink>
      <AdminError error={error} />
      <Card style={{ padding: 28 }}>
        <form method="POST" onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="grid grid-cols-6 gap-6">
            {/* 店舗名 */}
            <div className="col-span-6">
              <Input
                label="店舗名"
                name="name"
                register={register}
                required="店舗名を入力してください"
                maxLength={{ value: 20, message: "店舗名が長すぎます。" }}
                minLength={{ value: 1, message: "店舗名が短すぎます。" }}
                pattern={{ value: /.+/, message: "店舗名の形式が不正です。" }}
                password={false}
                autoComplete="username"
                placeholder=""
                icon={<IdentificationIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                errors={errors.name}
              />
            </div>

            <ImageInput label="店舗画像" required={false} name="image" watch={watch} aspectRatio={1 / 1} getValues={getValues} setError setValue={setValue}></ImageInput>

            {/* 郵便番号 */}
            <div className="col-span-6 sm:col-span-4">
              <InputPostalCode
                register={register}
                required="郵便番号を入力してください"
                errors={errors.postal_code}
                setValue={setValue}
                getValues={getValues}
                setError={setError}
              />
            </div>

            {/* 都道府県 */}
            <div className="col-span-6 sm:col-span-3">
              <Input
                label="都道府県"
                name="state"
                register={register}
                required="都道府県名を入力してください"
                maxLength={{ value: 6, message: "都道府県名が長すぎます" }}
                minLength={{ value: 1, message: "都道府県名が短すぎます" }}
                pattern={{ value: /^[ぁ-んァ-ヶー一-龠]+$/, message: '都道府県名の形式が不正です。' }}
                password={false}
                autoComplete="state"
                placeholder="例) 東京都"
                icon={<MapPinIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                errors={errors.state}
              />
            </div>

            {/* 市区町村名 */}
            <div className="col-span-6 sm:col-span-3">
              <Input
                label="市区町村名"
                name="city"
                register={register}
                required="市区町村名を入力してください"
                maxLength={{ value: 11, message: "市区町村名が長すぎます" }}
                minLength={{ value: 1, message: "市区町村名が短すぎます" }}
                pattern={{ value: /^[ぁ-んァ-ヶー一-龠]+$/, message: '市区町村名の形式が不正です。' }}
                password={false}
                autoComplete="city"
                placeholder="例) 渋谷区"
                icon={<MapPinIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                errors={errors.city}
              />
            </div>

            {/* 町名 */}
            <div className="col-span-6 sm:col-span-3">
              <Input
                label="町名"
                name="address_line_1"
                register={register}
                required="町名を入力してください"
                maxLength={{ value: 20, message: "町名が長すぎます" }}
                minLength={{ value: 1, message: "町名が短すぎます" }}
                pattern={{ value: /.+/, message: '町名の形式が不正です。' }}
                password={false}
                autoComplete="address_level3"
                placeholder="例) 代官山町"
                icon={<MapPinIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                errors={errors.addressLine1}
              />
            </div>

            {/* 番地 */}
            <div className="col-span-6 sm:col-span-3">
              <Input
                label="番地"
                name="address_line_2"
                register={register}
                required={false}
                maxLength={{ value: 20, message: "番地が長すぎます" }}
                minLength={{ value: 1, message: "番地が短すぎます" }}
                pattern={{ value: /.+/, message: '番地の形式が不正です。' }}
                password={false}
                autoComplete="address_level4"
                placeholder="例) 20-14"
                icon={<MapPinIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                errors={errors.addressLine2}
              />
            </div>

            {/* 位置情報 (緯度経度) */}
            <HubLocationPicker
              register={register}
              watch={watch}
              setValue={setValue}
              getValues={getValues}
              errors={errors}
              setError={setError}
            />
          </div>

          <div style={{ display: "flex", gap: 12, marginTop: 28, flexWrap: "wrap" }}>
            <PrimaryButton type="submit" style={{ flex: 1, minWidth: 160 }}>
              作成する
            </PrimaryButton>
            <GhostButton type="button" onClick={() => history.push("/sponsor/hubs")} style={{ minWidth: 120 }}>
              キャンセル
            </GhostButton>
          </div>
        </form>
      </Card>
    </AdminPage>
  );
};

export default HubsAddForm;
